import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["loading", "isRegenerate", "disabled", "size"];
import { getStyledAIIconButton } from './styledButtons/StyledAIBaseIconButton';
import { StyledAIBaseLoadingIconButtonAnimation } from './styledButtons/AILoadingIconButtonAnimations';
import { specialtyColor } from 'foundations-theming-specialty/utils';
import { BreezeRegenerateIcon } from 'foundations-assets/icons/components/BreezeRegenerateIcon';
import { BreezeSingleStarIcon } from 'foundations-assets/icons/components/BreezeSingleStarIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function AIBaseLoadingIconButton(_ref) {
  let {
      loading,
      isRegenerate,
      disabled,
      size
    } = _ref,
    uiIconButtonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const AIIconButtonComponent = getStyledAIIconButton(uiIconButtonProps.use);
  return /*#__PURE__*/_jsx(StyledAIBaseLoadingIconButtonAnimation, {
    size: size,
    children: /*#__PURE__*/_jsx("div", {
      className: loading ? 'loading-icon-wrapper spinning' : 'loading-icon-wrapper',
      children: /*#__PURE__*/_jsxs(AIIconButtonComponent, Object.assign({}, uiIconButtonProps, {
        disabled: disabled,
        size: size,
        use: disabled ? '' : 'transparent',
        children: [loading && /*#__PURE__*/_jsx(BreezeSingleStarIcon, {
          color: specialtyColor('breeze-icon-secondary-default')
        }), !loading && !isRegenerate && /*#__PURE__*/_jsx(BreezeSingleStarIcon, {}), !loading && isRegenerate && /*#__PURE__*/_jsx(BreezeRegenerateIcon, {})]
      }))
    })
  });
}